<template>
    <div id="add-media" class="modal inmodal fade" role="dialog" data-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <loading v-if="saving" :loading="saving"/>
                <modal-header :title="t_title"
                              :close-button="true"
                />
                <div class="modal-body scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <template v-if="overQuota === true">
                        <div class="alert alert-danger font-bold" v-html="t_over_quota"></div>
                    </template>
                    <template v-else>
                        <div class="wizard-notifications">
                            <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
                                {{ t_error }}
                                <ul>
                                    <li v-for="error in errors">
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <dropzone
                            v-if="!pixabayImport"
                            id="dz-add-media"
                            @uploadedFile="addUploadedFile"
                            @filesToUpload="filesToUploadChanged"
                        />
                        <div aria-label="uploaded file count" class="mt-2 mb-2">{{ t_uploaded_files_count }}</div>
                        <div class="collapseComponent mt-2" id="accordion_media_extendedcollapse" key="media_extendedcollapse" v-if="visible">
                            <div class="card">
                                <div class="card-header ibox-title" style="background-color: #f8fafb; padding: 5px 0;">
                                    <div class="ibox-tools">
                                        <a class="collapsed" ref="button"
                                           href="#content_media_extendedcollapse" aria-controls="content_media_extendedcollapse" :aria-expanded="!inner_collapsed"
                                           data-toggle="collapse" role="button"
                                           @click.passive="inner_collapsed = !inner_collapsed">
                                            <div style="font-weight: 700;">{{ t_extended_properties }}</div>
                                            <i ref="icon" :class="!inner_collapsed ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                                        </a>
                                    </div>
                                </div>
                                <div id="content_media_extendedcollapse"
                                     :aria-expanded="!inner_collapsed"
                                     data-parent="#accordion_media_extendedcollapse" class="collapse">
                                    <div class="card-body">
                                        <div class="pa-2" style="border-top: 0;">
<!--                                            NOTE: If something gets changed here,
                                                don't forget to change it in edit-media-modal.vue as well-->
                                            <tags :currentTags="currentTags" :allTags="allTags" :tagCreationPrivilege="tagCreationPrivilege"
                                                  @allTagsUpdated="updateAllTags" @currentTagsUpdated="updateCurrentTags"></tags>
                                            <usergroups v-model="strict_mode"
                                                        :currentUsergroups="currentUsergroups"
                                                        :allUsergroups="allUsergroups"
                                                        @allUsergroupsUpdated="updateAllUsergroups"
                                                        @currentUsergroupsUpdated="updateCurrentUsergroups"></usergroups>
                                            <layers :currentLayers="currentLayers"
                                                    :allLayers="allLayers"
                                                    @allLayersUpdated="updateAllLayers"
                                                    @currentLayersUpdated="updateCurrentLayers"></layers>
                                            <settings v-model="dateSettings"></settings>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-top m-t-md m-b-md" v-if="visible && !inner_collapsed && files.length > 0"></div>
                        <titles :files="files" :class="files.length > 0 ? 'mt-6' : ''"></titles>
                    </template>
                </div>
                <div class="d-flex flex-row align-center justify-end add-media-modal-padding">
                    <media-buttons
                        :saving="saving"
                        :disableSave="!saveable"
                        :approvePrivilege="approvePrivilege === '1'"
                        :publishPrivilege="publishPrivilege === '1'"
                        :updateApprove="updateApprove"
                        :updatePublish="updatePublish"
                        @cycleUpdatePublish="cycleUpdatePublish"
                        @cycleUpdateApprove="cycleUpdateApprove"
                        @confirm="saveWrapper"
                    />
                    <dialog-button
                        @click="cancelUpload"
                        :color="'secondary'"
                    >
                        {{ t_cancel }}
                    </dialog-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin";
    import MediaButtons from "./components/publish-buttons.vue";
    import DialogButton from "../../dialog/components/dialog-button.vue";
    import Loading from "../../common/loading.vue";
    import Tags from "./add/tags.vue";
    import Usergroups from "./add/usergroups.vue";
    import Layers from "./add/layers.vue";
    import Dropzone from "./add/dropzone.vue";
    import Settings from "./add/settings.vue";
    import Titles from "./add/titles.vue";
    import {transformCapitalizedJSONIntoSnakeCase} from "../../../utility";

    export default {
        mixins: [
            modalMixin,
        ],
        props: [
            'add',
            'backUrl',
            'insertX',
            'insertY',
            'overQuota',
            'approvePrivilege',
            'publishPrivilege',
            'tagCreationPrivilege'
        ],
        components: {
            Titles,
            Settings,
            Dropzone,
            Loading,
            DialogButton,
            MediaButtons,
            Layers,
            Usergroups,
            Tags,
        },
        data: function () {
            return {
                t_title: Lang.langGet("Add new media"),
                t_error: Lang.langGet("Failed to save media files:"),
                t_cancel: Lang.langGet("Cancel"),
                t_over_quota: Lang.langGet("The project is over the HDD quota.<br>Please delete some files, before you add new ones."),
                t_extended_properties: Lang.langGet("Extended Properties"),
                files: [],
                currentTags: [],
                allTags: [],
                currentUsergroups: [],
                allUsergroups: [],
                currentLayers: [],
                allLayers: [],
                strict_mode: false,
                dateSettings: {'from_date': '', 'to_date': ''},
                maxStep: 3,
                formStep: 1,
                animateElements: 'input, label, .file-manager, img, .chosen-container',
                errors: {},
                saving: false,
                modalName: 'add-media',
                filesToUpload: 0,
                updatePublish: 0,
                updateApprove: -1,
                inner_collapsed: true,
                visible: true,
                pixabayImport: false
            }
        },
        computed: {
            saveable: function () {
                let allFiles = [];

                if (this.files.length === 0) {
                    return false;
                }

                for (let i = 0; i < this.files.length; i++) {
                    const file = this.files[i];
                    let error = false;
                    let usedFile = false;

                    if (file.use) {
                        usedFile = true;

                        if (_.size(file.title) === 0) {
                            error = true;
                        }

                        if (_.size(file.file_name) === 0) {
                            error = true;
                        }

                        if (file.file_duplicate_upload) {
                            error = true;
                        }

                        if (file.file_regex) {
                            error = true;
                        }
                    }

                    allFiles.push({
                        used: usedFile,
                        error: error
                    });
                }
                return !allFiles.find(file => (file.error || !file.used));
            },
            t_uploaded_files_count: function () {
                if (this.files.length) {
                    return Lang.langGet(":count files uploaded", {
                        'count': this.files.filter((file) => {
                            return !(file.file_duplicate_checksum === true && file.use === false) &&
                                !(file.file_overwrite === 0 && file.file_duplicate_system === true && file.file_duplicate_upload === false);
                        }).length
                    })
                } else {
                    return '';
                }
            }
        },
        methods: {
            reset: function () {
                this.pixabayImport = false;
                _.extend(this.$data, this.$options.data());
                $(this.$el).find(this.animateElements).removeClass('animated');
                if (this.publishPrivilege && this.approvePrivilege) {
                    this.updatePublish = parseInt(localStorage.getItem("mediapool-publish-" + Laravel.activeProject) ?? 1);
                }
                if (this.approvePrivilege) {
                    this.updateApprove = parseInt(localStorage.getItem("mediapool-approve-" + Laravel.activeProject) ?? 1);
                }
            },
            updateCurrentTags: function (currentTags) {
                this.currentTags = currentTags;
            },
            updateAllTags: function (allTags) {
                this.allTags = allTags;
            },
            updateCurrentUsergroups: function (currentUsergroups) {
                this.currentUsergroups = currentUsergroups;
            },
            updateAllUsergroups: function (allUsergroups) {
                this.allUsergroups = allUsergroups;
            },
            updateCurrentLayers: function (currentLayers) {
                this.currentLayers = currentLayers;
            },
            updateAllLayers: function (allLayers) {
                this.allLayers = allLayers;
            },
            saveWrapper: function (approve=0, publish=0) {
                if (this.saving === true) {
                    return;
                }

                this.errors = {};
                this.saving = true;
                let data = {
                    approve: approve,
                    publish: publish
                };

                if (data.publish && !localStorage.getItem("mediapool-autopublish-confirm-" + Laravel.activeProject)
                    &&  (this.files.every((file) => file.file_duplicate_checksum === true && file.use === false && file.file_duplicate_title)
                        || !(this.currentTags.length === 0))) {
                    EaseEventBus.fire('showAutopublishWarning', {data: data, type: 'mediapool', task: 'Save', id: 'add-media'});
                } else {
                    this.save(data);
                }
            },
            save: function (data) {
                axios.post('/content/mediapool/add', {
                    tags: this.currentTags,
                    usergroups: this.currentUsergroups,
                    layers: this.currentLayers,
                    strict_mode: this.strict_mode,
                    files: this.files,
                    valid_to: this.dateSettings['valid_to'],
                    valid_from: this.dateSettings['valid_from'],
                    insertX: this.insertX,
                    insertY: this.insertY,
                    add: this.add,
                    approve: data.approve,
                    publish: data.publish,
                    isExternalImport: this.pixabayImport
                }).then((response) => {
                    this.saving = false;

                    if (this.add === '1') {
                        window.location = this.backUrl;
                    } else {
                        EaseEventBus.fire('hideModal', this.modalName);
                        EaseEventBus.fire('updateMedialist', );
                        EaseEventBus.fire('updateMedialistData', response.data);
                        this.visible = false;
                    }
                }).catch((error) => {
                    this.saving = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    } else if (error.response.status === 422) {
                        let tmpErrors = {};

                        for (let key in error.response.data.errors) {
                            tmpErrors[key] = error.response.data.errors[key][0];
                        }

                        this.errors = _.extend({}, this.errors, tmpErrors);
                    } else {
                        this.errors = _.extend({}, this.errors, error.response.data.data);
                    }
                });
            },
            addUploadedFile: function (file) {
                file.file_overwrite = 0;
                file.file_duplicate_upload = false;
                file.title_duplicate_upload = false;
                this.files.push(file);
            },
            cancelUpload: function () {
                EaseEventBus.fire('cancelUpload');
                EaseEventBus.fire('hideModal', 'add-media');
                this.visible = false;

                if (this.add === '1') {
                    window.location = this.backUrl;
                }
            },
            filesToUploadChanged(count) {
                this.filesToUpload = count;
            },
            cycleUpdatePublish: function () {
                this.updatePublish = (parseInt(this.updatePublish) + 1) % 2 || 0;
                localStorage.setItem("mediapool-publish-" + Laravel.activeProject, this.updatePublish);
            },
            cycleUpdateApprove: function () {
                this.updateApprove = (parseInt(this.updateApprove) + 1) % 3 || 0;
                this.updateApprove = this.updateApprove === 2 ? -1 : this.updateApprove;
                localStorage.setItem("mediapool-approve-" + Laravel.activeProject, this.updateApprove);
            }
        },
        mounted() {
            EaseEventBus.listen('showAddMediaModal', params => {
                this.reset();
                $(this.$el).find(this.animateElements).addClass('animated');

                if (params) {
                    this.pixabayImport = true;
                    /** @type{PixabayUploadResponse[]} */
                    const uploadResponses = params.uploadResponses;
                    this.files = uploadResponses.map(response => {
                        const file = transformCapitalizedJSONIntoSnakeCase(response.elements);
                        file.file_overwrite = 0;
                        file.file_duplicate_upload = false;
                        file.title_duplicate_upload = false;
                        return file;
                    });
                }

                EaseEventBus.fire('showModal', this.modalName);
            });

            EaseEventBus.listen('updateProceed', (data) => {
                if (data.type === 'mediapool' && data.task === 'Save' && data.id === 'add-media') {
                    if (data.proceed) {
                        this.save(data.data);
                    } else {
                        this.saving = false;
                    }
                }
            });
        }
    }
</script>

<style scoped>
    .add-media-modal-padding {
        padding: 16px 16px 16px 30px;
    }
    .border-top {
        border-width: 2px 0 0;
    }
</style>
